import { Outlet } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { useNavigationStore } from '../../stores/navigationStore';
import { useArbiterStore } from '../../stores/arbiterStore';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ArbiterPanel } from './ArbiterPanel';

export function MainLayout() {
  const { sidebarOpen } = useNavigationStore();
  const { panelOpen } = useArbiterStore();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      <Header />
      <Sidebar />
      <ArbiterPanel />

      <main
        className={cn(
          'min-h-screen pt-16 transition-all duration-300',
          sidebarOpen ? 'pl-60' : 'pl-16',
          panelOpen ? 'pr-[400px]' : 'pr-0'
        )}
      >
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
